<template>
  <div class="emails">
    <ba-header activeModule="Insured Messages"></ba-header>
    <div class="u-p4 main-content" v-loading="loading">
      <h2 class="c-heading__page u-mt4 u-pt2">User Messages</h2>
      <div class="block u-mt5 date-filter">
        <span class="u-mr2">From</span>
        <el-date-picker v-model="range.from" type="date" placeholder="Pick a date" format="MM/dd/yyyy">
        </el-date-picker>
        <span class="u-mr2 u-ml2">To</span>
        <el-date-picker v-model="range.to" type="date" placeholder="Pick a date" format="MM/dd/yyyy">
        </el-date-picker>
        <el-button icon="el-icon-search" @click="filterMessages()">Filter</el-button>
        <el-button v-if="range.from !== '' || range.to !== ''" @click="clearFilteredMessages">Clear Filter</el-button>
      </div>
      <div class="u-mt5">
        <el-checkbox class="u-mt3" v-model="consolidate" @change="loadInitial()">Consolidate Broadcast Messages</el-checkbox>
        <router-link :to="'create-campaign'">
          <el-button class="broadcast-message u-mb2 u-mr2">Create Broadcast Message</el-button>
        </router-link>
      </div>
      <div class="all-messages u-pr2">
        <el-table :data="messages" ref="messageTable" @sort-change="sortChange">
          <el-table-column
              label="Title"
              class-name="overflow-data"
              prop="title"
              columnKey="title"
              sortable
              >
          </el-table-column>
          <el-table-column
              label="Broadcast Name"
              class-name="overflow-data"
              prop="campaign_name"
              width="200"
              columnKey="campaign_name"
              sortable
          >
          </el-table-column>
          <el-table-column
              label="User"
              width="280"
          >
            <template slot-scope="scope">
              {{get_name(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column
              label="Type"
              class-name="centered-break-all"
              width="90"
              columnKey="message_type"
              sortable
          >
            <template slot-scope="scope">
              {{get_type(scope.row.message_type)}}
            </template>
          </el-table-column>
          <el-table-column
              label="Channels"
              class-name="centered-break-all"
              width="120"
              columnKey="channels"
              :render-header="renderChannelHeader"
          >
            <template slot-scope="scope">
              {{get_channels(scope.row.channels)}}
            </template>
          </el-table-column>
          <el-table-column
              label="Delivered Channels"
              class-name="centered-break-all"
              prop="sent"
              width="130"
              :render-header="renderChannelHeader"
          >
            <template slot-scope="scope">
              {{get_sent(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column
              label="Message Date/Time"
              class-name="centered-break-all"
              width="190"
              columnKey="created_at"
              sortable
          >
            <template slot-scope="scope">
              <div> {{scope.row.created_at | moment('MM/DD/YYYY hh:mm A')}}</div>
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="u-mt2" v-if="scope.row.details_html"><span class="detail-header">Push/MC Message (if applicable): </span>{{get_details(scope.row)}}</div>
              <div class="u-mt2" v-else><span class="detail-header">Message: </span>{{get_details(scope.row)}}</div>
              <div class="u-mt2" v-if="scope.row.phone_number"><span class="detail-header">Phone:</span> {{scope.row.phone_number}}</div>
              <div class="u-mt2" v-if="scope.row.details_html">
                <span class="detail-header">Email Message:</span>
                  <el-popover
                          placement="top-start"
                          width="700"
                          trigger="hover">
                    <icon class="u-mr1 mail-content__icon" slot="reference" scale="1" :name="'envelope'"></icon>
                    <div>
                      <div class="mail-content__detail">
                        <span v-html="get_details_html(scope.row)"/>
                      </div>
                    </div>
                  </el-popover> 
              </div>
              <div class="u-mt2" v-if="scope.row.seen_at"><span class="detail-header">Seen at: </span>{{scope.row.seen_at | moment('MM/DD/YYYY hh:mm A')}}</div>
              <div class="u-mt2" v-if="scope.row.dismissed"><span class="detail-header">Dismissed</span></div>
              <span class="u-mt2" v-if="scope.row.message_type.includes('broadcast') && consolidate">
                <div v-if="scope.row.scheduled_at"><span class="detail-header">Broadcast Start: </span>{{scope.row.scheduled_at | moment('MM/DD/YYYY hh:mm A')}}</div>
                <div v-if="scope.row.terminate_on"><span class="detail-header">Broadcast End: </span>{{scope.row.terminate_on | moment('MM/DD/YYYY hh:mm A')}}</div>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="response"  class="u-mt4" :layout="paginationLayout"
                       :total="response.count" :page-size="response.page_size"
                       :current-page="response.page" @current-change="loadPage">
        </el-pagination>
      </div>
    </div>
  </div>

</template>

<script>
/* eslint-disable */
import axios from 'axios'
import config from '@/config'
import {createTableHeaderHelp} from '@/shared/api.utils'

export default {
  components: {
  },
  name: 'ba-insured-messages',
  data () {
    return {
      companyId: this.$route.params.companyId,
      loading: true,
      response: null,
      consolidate: true,
      table: null,
      sort_column: null,
      sort_order: null,
      range: {
        from: '',
        to: '',
      },
    }
  },
  created() {
    this.page_size = 50
  },
  beforeMount () {
    this.loading = true
    this.loadInitial()
  },
  computed: {
    paginationLayout () {
      let moreThan15Pages = this.response && (this.response.total_pages > 15)
      return moreThan15Pages ? 'prev, pager, next, jumper' : 'prev, pager, next'
    },
    messages() {
      if (!this.response) {
        return []
      }
      return this.response.results
    },
  },
  methods: {
    renderChannelHeader (h, { column, $index }) {
      let txt = column.label == "Channels" ? "The channel(s) specified\r\nfor message.\r\n\r\n" : "The actual channel(s) the\r\nmessage was delivered in.\r\n\r\n"
      let channels = "E = Email\r\nN = App Notification\r\nP = Push Notification\r\nS = SMS Text"
      return createTableHeaderHelp(h, column.label, txt + channels, 'hover', 'top', 200, 'header-help__content')
    },
    loadPage: async function (page) {
      let url = config.url + `/company/${this.companyId}/insured-messages/`
      try {
        this.loading = true

        let params = {
          page: page,        
          page_size: this.page_size,
          consolidate: this.consolidate,
          sort_column: this.sort_column,
          sort_order: this.sort_order,
          from_date: this.$moment(this.range.from).format('MM-DD-YYYY'),
          to_date: this.$moment(this.range.to).format('MM-DD-YYYY'),
        }

        let response = await axios.get(url, {params: params})
        this.response = response.data
      } finally {
        this.loading = false
      }
    },
    loadInitial: async function () {
      await this.loadPage(1)
    },
    filterMessages: async function() {
      if (this.range.from === '' && this.range.to === '')
        return

      await this.loadPage(1)
    },
    sortChange(sortProperties) {
      this.table = this.$refs['messageTable']
      this.sort_column = null
      this.sort_order = null
      if (sortProperties.column != null) {
        this.sort_column = sortProperties.column.columnKey
        this.sort_order = sortProperties.order
      }
      this.loadPage(1)
    },
    get_channels: function (channels) {
      let channels_out = ''
      channels.forEach(function(element) {
        switch(element) {
          case 'notification':
          case 'message_center':
            channels_out += 'N,'
            break;
          default:
            channels_out += element.charAt(0).toUpperCase() + ','
        }
      })

      return channels_out.slice(0, -1)
    },
    get_type: function(type) {
      if (type.includes('single'))
        return 'User'

      if (type.includes('broadcast'))
        return 'Broadcast'
    },
    get_name: function(row) {
      if (row.message_type.includes('broadcast') && this.consolidate)
        return 'Multiple Users'

      return row.user_name
    },
    get_sent: function(row) {
      if (row.message_type.includes('broadcast') && this.consolidate)
        return 'N/A'

      if (row.sent === 0)
        return 'None'

      let delivery_methods = {'S': 8, 'N': 4, 'P': 2, 'E': 1}
      let label = ''

      Object.keys(delivery_methods).forEach(function(key, index){
        if (delivery_methods[key] & row.sent) {
          label += key + ','
        }
      })

      return label.slice(0, -1)
    },
    get_details: function(row) {
      if (row.message_type == 'reconfirm.broadcast' && this.consolidate) {
        return 'See individual messages for details.'
      }
      return row.details
    },
    get_details_html: function(row) {
      if (row.message_type == 'reconfirm.broadcast' && this.consolidate) {
        return 'See individual messages for details.'
      }
      return row.details_html
    },
    clearFilteredMessages () {
      this.range.from = ''
      this.range.to = ''
      return this.loadPage(1)
    },
  },
}
</script>

<style lang="scss">

  @import '../../styles/variables';

  .date-filter > button {
    vertical-align: top;
    margin-left: 5px;
  }

  .overflow-data > div.cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .overflow-data:hover > div.cell {
    overflow: visible;
    white-space: normal;
    height: auto;
  }

  .centered-break-all > div.cell {
    word-break: keep-all;
    text-align: center;
  }

  .broadcast-message {
    float: right;
  }

  .detail-header {
    font-weight: bold;
  }

  .mail-content__icon {
    position: relative;
    top: 0.2em;
    color: #455b5f;
  }

  .mail-content__icon:hover {
    color: #d8dce5;
  }

  .mail-content__detail {
    word-break: normal;
  }
  
  .mail-content__hide {
    display: none;
  }  

  .header-help__content {
    white-space: pre;
    overflow-wrap: break-word;
  } 
</style>

